<!-- 专题题库 -->
<template>
<div class="m-topic">
    <img :src="require('@/common/images/mSpecialTopic/topic_banner.png')" @click="handleBuyTopic(subjectList[0].code)" class="banner" />
    <div class="handle-box">
        <div class="handle-item" @click="handleOpenList('lxjl')">
            <img :src="require('@/common/images/mSpecialTopic/ztjl.png')" class="icon" />
            <div class="label">做题记录</div>
        </div>
        <div class="handle-item" @click="handleOpenList('wdsc')">
            <img :src="require('@/common/images/mSpecialTopic/wdsc.png')" class="icon" />
            <div class="label">我的收藏</div>
        </div>
        <div class="handle-item" @click="handleOpenList('wdct')">
            <img :src="require('@/common/images/mSpecialTopic/wdct.png')" class="icon" />
            <div class="label">我的错题</div>
        </div>
        <div class="handle-item" @click="handleBuyTopic(subjectList[0].code)">
            <img :src="require('@/common/images/mSpecialTopic/gmtk.png')" class="icon" />
            <div class="label">购买题库</div>
        </div>
    </div>
    <div class="module-name">备考刷题.快来练</div>
    <div class="exam-box">
        <div class="exam-item" @click="handleOpenList('zjlx')">
            <div class="text-info">
                <div class="name">章节练习</div>
                <div class="subname">知识点刷题</div>
            </div>
            <img :src="require('@/common/images/mSpecialTopic/zjlx.png')" class="icon" />
        </div>
        <div class="exam-item" @click="handleOpenList('mryl')">
            <div class="text-info">
                <div class="name">每日一练</div>
                <div class="subname">随机练习</div>
            </div>
            <img :src="require('@/common/images/mSpecialTopic/mryl.png')" class="icon" />
        </div>
        <div class="exam-item" @click="handleOpenList('lnzt')">
            <div class="text-info">
                <div class="name">历年真题</div>
                <div class="subname">真题真卷</div>
            </div>
            <img :src="require('@/common/images/mSpecialTopic/lnzt.png')" class="icon" />
        </div>
        <div class="exam-item" @click="handleOpenList('mnst')">
            <div class="text-info">
                <div class="name">模拟试题</div>
                <div class="subname">全真模拟演练</div>
            </div>
            <img :src="require('@/common/images/mSpecialTopic/zjlx.png')" class="icon" />
        </div>
    </div>
    <div class="module-name">开通题库.跟我练</div>
    <div class="subject-list">
        <div class="subject-item" v-for="(item) in subjectList" :key="item.code" @click="handleBuyTopic(item.code)">
            <div class="text-info">
                <div class="name">{{ item.name }}</div>
                <div class="expiredate" v-if="item.isjoin">有效期至：{{ item.expiredate }}</div>
                <div class="no-buy" v-if="!item.isjoin">暂未购买</div>
            </div>
            <div class="buy-btn">{{ item.isjoin ? '续费购买' : '立即购买' }}</div>
        </div>
    </div>
    <div class="footer-publicity" :class="{show: showFooterPublicity}">
        <img :src="require('@/common/images/mSpecialTopic/trumpet_icon.png')" class="trumpet-icon" />
        <div class="buy-btn" @click="handleBuyTopic(subjectList[0].code)">前往购买</div>
        <div class="close-box" @click="showFooterPublicity = false">
            <img :src="require('@/common/images/mSpecialTopic/close_icon.png')" class="close-icon" />
        </div>
    </div>
    <Mryl ref="mryl" :subjectList="subjectList" @handleBuyTopic="handleBuyTopic"></Mryl>
    <Zjlx ref="zjlx" :subjectList="subjectList" @handleBuyTopic="handleBuyTopic"></Zjlx>
    <Lnzt ref="lnzt" :subjectList="subjectList" @handleBuyTopic="handleBuyTopic"></Lnzt>
    <Mnst ref="mnst" :subjectList="subjectList" @handleBuyTopic="handleBuyTopic"></Mnst>
    <Wdct ref="wdct" :subjectList="subjectList"></Wdct>
    <Wdsc ref="wdsc" :subjectList="subjectList"></Wdsc>
    <Lxjl ref="lxjl" :subjectList="subjectList"></Lxjl>
    <BuyPopup ref="buyPopup"></BuyPopup>
</div>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {getTopicQBBaseInfo} from '@/api/api.js'
import {mapGetters, mapActions} from 'vuex'
import Mryl from './topicComponent/mryl.vue'
import Zjlx from './topicComponent/zjlx.vue'
import Lnzt from './topicComponent/lnzt.vue'
import Mnst from './topicComponent/mnst.vue'
import Wdct from './topicComponent/wdct.vue'
import Wdsc from './topicComponent/wdsc.vue'
import Lxjl from './topicComponent/lxjl.vue'
import BuyPopup from './component/buyPopup.vue'
export default {
    data() {
        return {
            subjectList: [],
            showFooterPublicity: true
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'SpecialTopic',
                params: {
                    examcode: this.$route.params.examcode
                }
            })
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        if (this.$route.params.examcode) {
            if (this.user.loginToken) {
                this.handleGetTopicQBBaseInfo()
            } else {
                this.subjectList = JSON.parse(JSON.stringify(specialTopic.subject[this.$route.params.examcode]))
                if (this.subjectList && this.subjectList.length) {
                    this.activeSubject = JSON.parse(JSON.stringify(this.subjectList[0]))
                    this.$nextTick(() => {
                        // this.$refs.mryl.handleInit()
                    })
                }
            }
        }
    },
    methods: {
        handleGetTopicQBBaseInfo() {
            this.setLoading(true)
            getTopicQBBaseInfo({
                data: {examcode: this.$route.params.examcode},
                success: data => {
                    this.setLoading(false)
                    data.data.subjectlist.forEach(item => {
                        item.init = false
                        item.list = []
                        item.activeNames = []
                        item.loadingmore = false
                        item.finished = false
                        item.topicinfo = {
                            pageinfo: {
                                pageCount: 1,
                                pageNum: 1,
                                pageSize: 10,
                                rowCount: 0
                            },
                            quesbanklist: [],
                            bankid: '',
                            bankinfolist: [],
                            datatype: 0
                        }
                        if (item.isjoin) {
                            this.showFooterPublicity = false
                        }
                    })
                    this.subjectList = data.data.subjectlist
                    if (this.$route.query.subjectcode && this.$route.query.section) {
                        this.handleOpenList(this.$route.query.section)
                    }
                    // if (this.subjectList && this.subjectList.length) {
                    //     this.activeSubject = JSON.parse(JSON.stringify(this.subjectList[0]))
                    //     this.$nextTick(() => {
                    //         if (this.activeTabsIndex === 0) {
                    //             this.$refs.mryl.handleInit()
                    //         } else if (this.activeTabsIndex === 1) {
                    //             this.$refs.zjlx.handleInit()
                    //         } else if (this.activeTabsIndex === 2) {
                    //             this.$refs.lnzt.handleInit()
                    //         } else if (this.activeTabsIndex === 3) {
                    //             this.$refs.mnst.handleInit()
                    //         } else if (this.activeTabsIndex === 4) {
                    //             this.$refs.wdct.handleInit()
                    //         } else if (this.activeTabsIndex === 5) {
                    //             this.$refs.wdsc.handleInit()
                    //         } else if (this.activeTabsIndex === 6) {
                    //             this.$refs.lxjl.handleInit()
                    //         }
                    //     })
                    // }
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleOpenList(name) {
            if (name === 'mryl' || name === 'zjlx' || name === 'lnzt' || name === 'mnst' || name === 'wdct' || name === 'wdsc' || name === 'lxjl') {
                if (name === 'lxjl' || name === 'wdct' || name === 'wdsc') {
                    if (this.user.loginToken) {
                        this.$refs[name].handleOpen()
                    } else {
                        this.$router.push({
                            name: 'MLogin'
                        })
                    }
                } else {
                    this.$refs[name].handleOpen()
                }
            }
        },
        handleBuyTopic(subjectcode) {
            if (this.user.loginToken) {
                this.$refs.buyPopup.handleOpen(this.$route.params.examcode, subjectcode)
            } else {
                this.$router.push({
                    name: 'MLogin'
                })
            }
        },
        ...mapActions([
            'setLoading',
            'setUser'
        ])
    },
    computed: {
        ...mapGetters(
            ['user', 'domainlist','domainInfo', 'loading']
        )
    },
    watch: {
        'user': {
            handler(newV, oldV) {
                if (!oldV.loginToken && newV.loginToken) {
                    // this.$refs.mryl.init = false
                    // this.$refs.zjlx.init = false
                    // this.$refs.lnzt.init = false
                    // this.$refs.mnst.init = false
                    this.handleGetTopicQBBaseInfo()
                } else if (!newV.loginToken) {
                    this.subjectList.forEach(item => {
                        item.isjoin = 0
                    })
                    // this.activeSubject.isjoin = 0
                }
            },
            deep: true
        }
    },
    components: {
        Mryl,
        Zjlx,
        Lnzt,
        Mnst,
        Wdct,
        Wdsc,
        Lxjl,
        BuyPopup
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-topic {
    padding: 0.32rem 0.28rem 1.2rem;
    box-sizing: border-box;
    .banner {
        width: 100%;
        height: 2rem;
        border-radius: 0.1rem;
        margin-bottom: 0.32rem;
    }
    .handle-box {
        width: 100%;
        height: 1.2rem;
        background: #fff;
        border-radius: 0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 0.32rem;
        .handle-item {
            width: 0.8rem;
            text-align: center;
            .icon {
                width: 0.4rem;
                height: 0.4rem;
                margin-bottom: 0.1rem;
                display: inline;
            }
            .label {
                font-size: 0.2rem;
                color: #666666;
                line-height: 0.28rem;
            }
        }
    }
    .module-name {
        font-size: 0.3rem;
        font-weight: bold;
        line-height: 0.42rem;
        margin-bottom: 0.32rem;
        color: #333333;
    }
    .exam-box {
        height: 2.55rem;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        border-radius: 0.1rem;
        margin-bottom: 0.32rem;
        .exam-item {
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.4rem;
            box-sizing: border-box;
            .text-info {
                .name {
                    font-size: 0.26rem;
                    color: #333333;
                    font-weight: bold;
                    line-height: 0.36rem;
                }
                .subname {
                    font-size: 0.2rem;
                    color: #999999;
                    line-height: 0.28rem;
                }
            }
            .icon {
                width: 0.48rem;
                height: 0.48rem;
            }
        }
    }
    .subject-list {
        background: #fff;
        padding: 0 0.4rem;
        border-radius: 0.1rem;
        .subject-item {
            padding: 0.28rem 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:not(:last-of-type) {
                border-bottom: 0.01rem solid #E5E5E5;
            }
            .text-info {
                .name {
                    font-size: 0.28rem;
                    color: #333333;
                    line-height: 0.4rem;
                    margin-bottom: 0.1rem;
                }
                .expiredate {
                    font-size: 0.24rem;
                    color: #FF4E21;
                    line-height: 0.34rem;
                }
                .no-buy {
                    font-size: 0.24rem;
                    color: #999999;
                    line-height: 0.34rem;
                }
            }
            .buy-btn {
                width: 1.5rem;
                height: 0.4rem;
                background: linear-gradient( 180deg, #FFECBB 0%, #D39D26 100%);
                box-shadow: 0px 0.04rem 0.04rem 0px rgba(0,0,0,0.25);
                border-radius: 1rem;
                text-align: center;
                line-height: 0.4rem;
                color: #785B18;
                font-size: 0.24rem;
            }
        }
    }
    .footer-publicity {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1rem;
        background: url('../../../../common/images/mSpecialTopic/footer_bg.png');
        background-size: 100% 100%;
        display: none;
        justify-content: space-between;
        padding: 0 0.4rem 0 0;
        box-sizing: border-box;
        &.show {
            display: flex;
        }
        .trumpet-icon {
            width: 1.82rem;
            height: 1.3rem;
            position: relative;
            top: -0.25rem;
            left: -0.05rem;
        }
        .buy-btn {
            width: 1.5rem;
            height: 0.4rem;
            text-align: center;
            line-height: 0.4rem;
            position: relative;
            top: 0.3rem;
            background: linear-gradient( 180deg, #FFECDF 0%, #FBC06E 100%);
            box-shadow: 0px 0.04rem 0.04rem 0px rgba(0,0,0,0.25);
            border-radius: 1rem;
            font-size: 0.24rem;
            color: #C75910;
        }
        .close-box {
            position: absolute;
            top: 0;
            right: 0;
            width: 0.34rem;
            height: 0.34rem;
            padding-top: 0.1rem;
            padding-right: 0.1rem;
            box-sizing: border-box;
            .close-icon {
                width: 0.24rem;
                height: 0.24rem;
            }
        }
    }
}
</style>